import createSvgIcon from "./utils/create_icon"

const Search = createSvgIcon(<path clipRule="evenodd" d="M11 3a8 8 0 1 0 4.906 14.32l3.387 3.387a1 1 0 0 0 1.414-1.414l-3.387-3.387A8 8 0 0 0 11 3zm-6 8a6 6 0 1 1 12 0 6 6 0 0 1-12 0z" fill="currentColor" fillRule="evenodd" />, "Search")
export default Search
